import { type IInternalContact } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IInternalContactState } from './types';

export const GET_MATCHES = 'getMatches';

export const getters: GetterTree<IInternalContactState, unknown> = {
    [GET_MATCHES]: (_state) => {
        return (contactId: number): IInternalContact[] => {
            return _state.matches.get(contactId);
        };
    }
};
